import React, { SVGProps } from "react";

export default function DefaultProductIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Assets"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-229.000000, -310.000000)" id="ic_custom">
          <g transform="translate(229.000000, 310.000000)">
            <g>
              <rect
                id="Rectangle"
                fill="#FFFFFF"
                x="1"
                y="1"
                width="38"
                height="38"
                rx="2"
              ></rect>
              <rect
                id="Rectangle"
                fill="#A8A8A8"
                fillRule="nonzero"
                x="10.6402701"
                y="28.0958765"
                width="26.1188329"
                height="2.35456957"
              ></rect>
              <path
                d="M36.759103,4.32167832 C36.7536445,3.57934405 36.1503119,2.98046781 35.4079576,2.98046781 L4.32167832,2.98046781 C3.58094821,2.98046781 2.98046781,3.58094821 2.98046781,4.32167832 L2.98046781,35.4178925 C2.98046781,36.1586226 3.58094821,36.759103 4.32167832,36.759103 L35.4079576,36.759103 C36.1503119,36.759103 36.7536445,36.1602267 36.759103,35.4178925 L36.759103,4.32167832 Z"
                id="Path"
              ></path>
              <polygon
                id="Path"
                fill="#A8A8A8"
                fillRule="nonzero"
                points="17.1376899 2.98046781 36.759103 22.6018809 36.759103 19.2736918 20.4658789 2.98046781"
              ></polygon>
              <path
                d="M16.8694478,21.0917772 C16.2332922,20.2958348 15.8833652,19.3090405 15.8759585,18.2901374 C15.8753794,17.6858582 15.9970375,17.0877055 16.2336147,16.5316614 L3.23877502,3.29838437 C3.16534091,3.36648884 3.10476568,3.4472558 3.05994695,3.5368218 L3.05994695,34.9509525 L9.95476248,28.0760068 L16.8694478,21.0917772 Z"
                id="Path"
                fill="#77C7A7"
              ></path>
              <path
                d="M3.36792862,3.17916566 C3.36792862,3.17916566 3.30831927,3.17916566 3.28844948,3.24870991 C3.2685797,3.31825416 3.33812395,3.20897034 3.36792862,3.17916566 Z"
                id="Path"
                fill="#77C7A7"
              ></path>
              <path
                d="M20.4758138,13.6604775 C21.5154326,13.6527558 22.5259381,14.0036258 23.3370629,14.6539667 L26.108898,11.8821317 L17.1674946,2.94072824 L7.37169038,2.94072824 L18.4093562,14.1870268 C19.0470145,13.8510083 19.7551097,13.6705802 20.4758138,13.6604775 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <path
                d="M34.5734266,20.4261394 L28.3243791,14.1770919 L24.99619,17.5052809 C25.0477081,17.7637581 25.074323,18.0265796 25.0756692,18.2901374 C25.072286,19.0526575 24.8739253,19.8016402 24.4994454,20.4658789 L29.4668917,25.5724138 L34.5734266,20.4261394 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <path
                d="M27.0527128,28.0958765 L27.31102,27.8176995 L22.1548107,22.5621413 C21.6214662,22.7784821 21.0513655,22.8898036 20.4758138,22.8899928 C20.2125419,22.8836984 19.9501464,22.8571267 19.6909573,22.8105136 L14.4155293,28.0958765 L27.0527128,28.0958765 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <polygon
                id="Path"
                fill="#BEBEBE"
                points="35.0801061 2.98046781 20.4658789 2.98046781 27.77796 10.2925488"
              ></polygon>
              <path
                d="M21.9362431,18.2901374 C21.9362431,17.4835647 21.2823866,16.8297082 20.4758138,16.8297082 C19.6692411,16.8297082 19.0153846,17.4835647 19.0153846,18.2901374 C19.0153846,19.0967102 19.6692411,19.7505667 20.4758138,19.7505667 C21.2823866,19.7505667 21.9362431,19.0967102 21.9362431,18.2901374 L21.9362431,18.2901374 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <polygon
                id="Path"
                fill="#BEBEBE"
                points="36.759103 33.4504461 36.759103 30.4504461 33.759103 30.4504461"
              ></polygon>
              <path
                d="M36.6696889,36.1530745 C36.6435806,36.2048753 36.6136952,36.2546843 36.5802749,36.3020979 C36.6136952,36.2546843 36.6435806,36.2048753 36.6696889,36.1530745 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <polygon
                id="Path"
                fill="#BEBEBE"
                points="12.0609597 30.4504461 5.74236798 36.759103 18.5484447 36.759103 24.7378828 30.4504461"
              ></polygon>
              <polygon
                id="Path"
                fill="#BEBEBE"
                points="36.2226188 18.7471425 36.759103 18.2007234 36.759103 5.75230287 29.993441 12.5080299"
              ></polygon>
              <path
                d="M36.3120328,36.6001447 C36.2299645,36.6524969 36.1390786,36.6895245 36.0437907,36.7094285 C36.1390786,36.6895245 36.2299645,36.6524969 36.3120328,36.6001447 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <path
                d="M29.8940921,30.4504461 L29.1390403,30.4504461 L22.9496021,36.759103 L35.8649626,36.759103 C35.9407866,36.7693341 36.0176412,36.7693341 36.0934652,36.759103 L29.8940921,30.4504461 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <path
                d="M36.3418375,36.57034 C36.4111202,36.5254048 36.4745303,36.4720069 36.5306004,36.4113817 C36.4745303,36.4720069 36.4111202,36.5254048 36.3418375,36.57034 L36.3418375,36.57034 Z"
                id="Path"
                fill="#BEBEBE"
              ></path>
              <path
                d="M37,1 C38.1045695,1 39,1.8954305 39,3 L39,37 C39,38.1045695 38.1045695,39 37,39 L3,39 C1.8954305,39 1,38.1045695 1,37 L1,3 C1,1.8954305 1.8954305,1 3,1 L37,1 M37,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,37 C0,38.6568542 1.34314575,40 3,40 L37,40 C38.6568542,40 40,38.6568542 40,37 L40,3 C40,1.34314575 38.6568542,0 37,0 Z"
                id="Border"
                fill="#E5E5E5"
                fillRule="nonzero"
              ></path>
              <polygon
                id="Path"
                fill="#BEBEBE"
                points="36.759103 28.0958765 36.759103 22.6912949 31.4706268 28.0958765 31.9903545 28.0958765"
              ></polygon>
              <path
                d="M36.759103,18.2007234 L29.5165662,25.5724138 L24.5491198,20.4658789 C24.9235998,19.8016402 25.1219605,19.0526575 25.1253436,18.2901374 C25.1239974,18.0265796 25.0973826,17.7637581 25.0458645,17.5052809 L36.8087774,5.75230287 L36.8087774,3.91434772 C36.7789153,3.4076656 36.3719324,3.00496665 35.8649626,2.98046781 L35.1297806,2.98046781 L23.3867374,14.723511 C22.5756126,14.07317 21.5651071,13.7223001 20.5254883,13.7300217 C19.7904954,13.7368724 19.0679985,13.9209046 18.4192911,14.2665059 L7.38162527,3.02020738 L3.88454304,3.02020738 C3.622725,3.02110431 3.37358029,3.13303889 3.19903545,3.32818905 L16.20381,16.571401 C15.9672329,17.1274451 15.8455747,17.7255978 15.8461538,18.329877 C15.8400512,19.3692283 16.1907385,20.3792079 16.8396431,21.1911261 L2.93079334,35.0999759 L2.93079334,35.8351579 C2.91430153,36.0929945 3.00536233,36.3461422 3.18231802,36.5343929 C3.35927371,36.7226437 3.60631038,36.8291741 3.86467326,36.8286472 L5.69269351,36.8286472 L19.6015433,22.9197974 C19.8607323,22.9664105 20.1231279,22.9929822 20.3863998,22.9992766 C20.9619514,22.9990874 21.5320522,22.8877659 22.0653967,22.6714251 L27.221606,27.9269834 L18.4590306,36.8683868 L22.8601881,36.8683868 L29.4271522,30.1722691 L36.0437907,36.8187123 C36.4604365,36.722146 36.7563508,36.3522532 36.759103,35.924572 L36.759103,33.0633229 L31.6227634,27.9269834 L36.759103,22.6912949 L36.759103,18.2007234 Z M20.4758138,19.7505667 C19.6692411,19.7505667 19.0153846,19.0967102 19.0153846,18.2901374 C19.0153846,17.4835647 19.6692411,16.8297082 20.4758138,16.8297082 C21.2823866,16.8297082 21.9362431,17.4835647 21.9362431,18.2901374 C21.9362431,18.6774674 21.7823769,19.0489332 21.5084933,19.3228169 C21.2346096,19.5967005 20.8631438,19.7505667 20.4758138,19.7505667 L20.4758138,19.7505667 Z"
                id="Shape"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
